import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center sm:w-full md:w-2/3" }
const _hoisted_2 = { class: "py-2" }
const _hoisted_3 = { class: "my-4 w-full" }

import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { PageSection } from "@/apps/page/page.interfaces";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import {
    TAB_NEW_PROJECT,
    useBindSectionWithProject,
} from "@/apps/page/project/sections/useBindWithProject";
import BindSectionWithToolProjectForm from "@/apps/page/project/sections/BindSectionWithToolProjectForm.vue";
import { useEditorActions } from "@/views/tools/page/utils/useEditorActions";
import { ref } from "vue";
import { AddIcon } from "@easy/ui/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'BindSectionWithToolPanel',
  props: {
    sectionId: {},
    tool: {}
  },
  setup(__props: any) {

const { connectToolSectionWithProject, bindToolSectionWithProject } = useEditorActions();
const props = __props;
const {
    selectedTab,
    chosenProjectId,
    shouldHaveExistingOption,
    toolProjects,
    project,
    projectNameError,
    bindWithProject,
    resetForm,
    onFieldBlur,
} = useBindSectionWithProject(props, {
    page: ref({ uuid: "" }),
    routeAfterBind: false,
    connectToolSectionWithProject,
    bindToolSectionWithProject,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(shouldHaveExistingOption)
                    ? _ctx.$t("page.bind_section_panel.description")
                    : _ctx.$t("page.bind_section_panel.description_creation")), 1),
    _createVNode(BindSectionWithToolProjectForm, {
      class: "w-full",
      isAutofocused: false,
      sectionId: _ctx.sectionId,
      tool: _ctx.tool,
      toolProjects: _unref(toolProjects),
      pageNameBlur: _unref(onFieldBlur),
      projectNameError: _unref(projectNameError),
      onTabSwitched: _unref(resetForm),
      onActionSubmit: _unref(bindWithProject),
      selectedTab: _unref(selectedTab),
      "onUpdate:selectedTab": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedTab) ? (selectedTab).value = $event : null)),
      shouldHaveExistingOption: _unref(shouldHaveExistingOption),
      "onUpdate:shouldHaveExistingOption": _cache[1] || (_cache[1] = ($event: any) => (_isRef(shouldHaveExistingOption) ? (shouldHaveExistingOption).value = $event : null)),
      chosenProjectId: _unref(chosenProjectId),
      "onUpdate:chosenProjectId": _cache[2] || (_cache[2] = ($event: any) => (_isRef(chosenProjectId) ? (chosenProjectId).value = $event : null)),
      projectName: _unref(project).projectName,
      "onUpdate:projectName": _cache[3] || (_cache[3] = ($event: any) => ((_unref(project).projectName) = $event))
    }, null, 8, ["sectionId", "tool", "toolProjects", "pageNameBlur", "projectNameError", "onTabSwitched", "onActionSubmit", "selectedTab", "shouldHaveExistingOption", "chosenProjectId", "projectName"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ButtonPrimaryMd), {
        class: "w-full",
        onClick: _unref(bindWithProject)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AddIcon)),
          _createTextVNode("  " + _toDisplayString(_unref(selectedTab) === _unref(TAB_NEW_PROJECT)
                        ? _ctx.$t("page.bind_section_modal.project_new")
                        : _ctx.$t("page.bind_section_modal.fill_with_project", { tool: _ctx.tool })), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}
}

})